import { observer } from 'mobx-react';
import React from 'react';
import { useStores } from '../../stores/RootStore';
import Config from '../../Config';
import { Go3AppCarousel } from '@teliaee/telia-common-components';

interface TagProp {
  tagText: string;
  productCode: string;
}

interface Go3AppCardsProps {
  tags?: TagProp[];
}

export const Go3AppCards = observer((props: Go3AppCardsProps) => {
  const { languageStore, ssoStore } = useStores();

  return (
    <Go3AppCarousel
      app="public"
      language={languageStore.currentLanguage}
      tier={Config.componentTier}
      tags={props.tags}
      isSsoLoaded={ssoStore.initialSsoMessageReceived}
      openSsoFrame={ssoStore.openSsoFrame}
      teliaWebSelfServiceUrl={Config.teliaWebSelfServiceUrl}
      ensureLoginWithGotoUrl={ssoStore.ensureLoginWithGotoUrl}
    />
  );
});
